export const INTERNAL_ADMIN_PATH = '/internal-admin';

// The internal admin authenticates with the KADMINUSER cookie, which the server
// only honours when no Bearer is sent. Inside the admin, a Khub user session
// left in this browser must therefore stay invisible, or every shared endpoint
// would answer as that user instead of the admin.
export const isInternalAdminPage = (): boolean => {
  // Lowercased like React Router, which matches paths case-insensitively.
  const pathname = window.location.pathname.toLowerCase();
  return (
    pathname === INTERNAL_ADMIN_PATH ||
    pathname.startsWith(`${INTERNAL_ADMIN_PATH}/`)
  );
};
